import { useEffect, useState } from "react";
import { getProductInfo } from "src/utils/storage/product";
import { createServicePremiumBill } from "src/service/pay";
import { ICreateServiceBillReq } from "src/service/types/pay.type";
import { notifyError } from "src/components/Common/Toast";
import { useRouter } from "src/hooks/useRouter";
import { useRecoilState } from "recoil";
import { navStepAtom, userInfoAtom } from "src/atoms";
import EdrmPromotionUI from "./Dsp.presenter";
import { useGetMySiteStatus } from "src/hooks/recoil/useGetMySiteStatus";
import { useTranslation } from "react-i18next";

const PromotionDspContainer = () => {
  const [promotionCode, setPromotionCode] = useState<string>("");
  const [userInfo, setUserInfo] = useRecoilState(userInfoAtom);
  const [isCheckPromotionCode, setIsCheckPromotionCode] =
    useState<string>("NONE");
  const [isRenew, setIsRenew] = useState(false);
  const [serviceBillUid, setServiceBillUid] = useState("");
  // const [referralId, setReferralId] = useState("");
  const [navStep, setNavStep] = useRecoilState(navStepAtom);
  // 추후 쓸일있을지 검토
  const [isApplyDone, setIsApplyDone] = useState(false);
  // 요새 안쓰는 UI (프로모션 코드가 적용되었습니다.)
  const [isCreateDone, setIsCreateDone] = useState(false);
  const [isHasSite, setIsHasSite] = useState(true);
  const { t } = useTranslation();
  const productName = getProductInfo().name;
  const [toggleAskPromotionOn, setToggleAskPromotionOn] = useState(false);
  const route = useRouter();
  // 프로모션 코드 적용 (Wrapsody, eCo)
  const promotionApply = async ({
    issueAppList,
    referralId,
    promotionCode,
  }: {
    issueAppList: string[];
    referralId: string;
    promotionCode: string;
  }) => {
    if (isCheckPromotionCode !== "OK") {
      notifyError(t("siteType.premium.detail.plan.invalidPromotionCode"));
      return;
    }
    // if (
    //   //this.state.priceType === 'promotion' &&
    //   this.state.nxacAppUids.length < 4
    // ) {
    //   alert(t('cashStatus.chooseAppFour'))
    //   return
    // }

    // 고정 요청값
    const defaultRequest: ICreateServiceBillReq = {
      userCode: userInfo.userCode,
      billType: "PROMOTION",
      billCode: promotionCode,
      serviceId: "",
      region: "",
      product: "",
      serviceName: "",
      referralId,
      nxacAppUids: issueAppList ?? [],
    };
    let serviceRequest: ICreateServiceBillReq = {};
    if (promotionCode !== "" && !isRenew) {
      serviceRequest = {
        ...defaultRequest,
        serviceBillUid: "",
        currency: "WON",
        payCompany: "CASH",
      };
    } else if (promotionCode !== "" && isRenew) {
      serviceRequest = {
        ...defaultRequest,
        serviceBillUid: serviceBillUid,
      };
    }

    // console.log("createServiceBill", serviceRequest);
    await createServicePremiumBill({
      // ...serviceRequest,
      promotionCode,
    })
      .then((result) => {
        console.log("사이트생성이여~", result);
        route.goConsole();
      })
      .catch((error: any) => {
        if (error.errorCode && error.errorMessage) {
          alert(error.errorMessage);
        }
      });
  };
  const { getMySiteStatus } = useGetMySiteStatus();
  useEffect(() => {
    async function init() {
      setNavStep(2); // 구독 결제정보 입력
      // await this.commonStore.getMySiteStatus()
      await getMySiteStatus({});
      window.sessionStorage.removeItem("payType");
      // if (!this.commonStore.confirmPromotion) {
      //   window.location.href = `${process.env.PUBLIC_URL}/${lang}/site/type`
      // }
      // isRenewService({ route });
    }
    init();
  }, []);
  return (
    <EdrmPromotionUI
      promotionCode={promotionCode}
      setPromotionCode={setPromotionCode}
      isCheckPromotionCode={isCheckPromotionCode}
      setIsCheckPromotionCode={setIsCheckPromotionCode}
      promotionApply={promotionApply}
      productName={productName}
      toggleAskPromotionOn={toggleAskPromotionOn}
      setToggleAskPromotionOn={setToggleAskPromotionOn}
    />
  );
};

export default PromotionDspContainer;
